import { $ } from "@/common/Axios";

export default {
  /**
   * 成考考区
   */
  adultExamArea: {
    /*
     * 添加
     * area 成考考区 (string query )
     * city 成考县级市 (string query )
     * enrollPoint 报名点 (string query )
     * id  (integer query )
     * province 省份 (string query )
     */
    post: (p, c) => $.post("/api/ems/basic/adultExamArea", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/basic/adultExamArea", p, c),
  },
  adultExamArea_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/basic/adultExamArea/export", p, c),
  },
  adultExamArea_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/basic/adultExamArea/list", p, c),
  },
  adultExamArea_listArea: {
    /*
     * 考区列表
     * province 省份 (string query )
     */
    get: (p, c) => $.get("/api/ems/basic/adultExamArea/listArea", p, c),
  },
  adultExamArea_listCity: {
    /*
     * 县级市列表
     * area 考区 (string query )
     * province 省份 (string query )
     */
    get: (p, c) => $.get("/api/ems/basic/adultExamArea/listCity", p, c),
  },
  adultExamArea_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/basic/adultExamArea/upload", p, c),
  },

  /**
   * 文件政策管理
   */
  basicEduFile_list: {
    /*
     * 学历教育平台-文件政策列表
     */
    get: (p, c) => $.get("/api/ems/basic/basicEduFile/list", p, c),
  },
  basicEduFile_listForBasic: {
    /*
     * 基础平台-文件政策列表
     */
    get: (p, c) => $.get("/api/ems/basic/basicEduFile/listForBasic", p, c),
  },
  basicEduFile_listForFin: {
    /*
     * 财务平台-文件政策列表
     */
    get: (p, c) => $.get("/api/ems/basic/basicEduFile/listForFin", p, c),
  },
  basicEduFile_listForPersonnel: {
    /*
     * 人事平台-文件政策列表
     */
    get: (p, c) => $.get("/api/ems/basic/basicEduFile/listForPersonnel", p, c),
  },
  basicEduFile_listForProgram: {
    /*
     * 技术平台-文件政策列表
     */
    get: (p, c) => $.get("/api/ems/basic/basicEduFile/listForProgram", p, c),
  },
  basicEduFile_listRecord: {
    /*
     * 历史版本列表
     * id 行ID (integer query required)
     */
    get: (p, c) => $.get("/api/ems/basic/basicEduFile/listRecord", p, c),
  },
  basicEduFile_remove: {
    /*
     * 删除
     * id ID (integer query )
     */
    delete: (p, c) => $.delete("/api/ems/basic/basicEduFile/remove", p, c),
  },
  basicEduFile_save: {
    /*
     * 添加-学历教育平台
     * category 分类 (string query required)
     * extraUrl 附件地址 (string query required)
     * name 名称 (string query required)
     * platform 平台 (string query required)
     * type 类型：政策文件、学位文件等 (string query required)
     */
    post: (p, c) => $.post("/api/ems/basic/basicEduFile/save", p, c),
  },
  basicEduFile_update: {
    /*
     * 编辑
     * category 分类 (string query required)
     * extraUrl 附件地址 (string query required)
     * id id (integer query required)
     * name 名称 (string query required)
     * type 类型：政策文件、学位文件等 (string query required)
     */
    post: (p, c) => $.post("/api/ems/basic/basicEduFile/update", p, c),
  },

  /**
   * 批次
   */
  batch: {
    /*
     * 添加编辑
     * ableStatus 启用状态 (string query )
     * batch 批次 (string query )
     * id  (integer query )
     * siteType 学校类型 (string query )
     */
    post: (p, c) => $.post("/api/ems/basic/batch", p, c),

    /*
     * 删除, 学生数量为0的才可以删
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/basic/batch", p, c),
  },
  batch_exportForAdult: {
    /*
     * 导出-学历教育-学历配置-学籍状态管理
     */
    get: (p, c) => $.get("/api/ems/basic/batch/exportForAdult", p, c),
  },
  batch_exportForArmy: {
    /*
     * 导出-中军职达-职业技能培训-基础配置-批次管理
     */
    get: (p, c) => $.get("/api/ems/basic/batch/exportForArmy", p, c),
  },
  batch_exportForContinue: {
    /*
     * 导出-继续教育-教务配置-批次管理
     */
    get: (p, c) => $.get("/api/ems/basic/batch/exportForContinue", p, c),
  },
  batch_exportForExemptionDegree: {
    /*
     * 导出-免试专升本-学历配置-批次管理
     */
    get: (p, c) => $.get("/api/ems/basic/batch/exportForExemptionDegree", p, c),
  },
  batch_exportForSelfTaught: {
    /*
     * 导出-自考平台-基础配置-批次管理
     */
    get: (p, c) => $.get("/api/ems/basic/batch/exportForSelfTaught", p, c),
  },
  batch_exportForSkillTrain: {
    /*
     * 导出-技能培训-基础配置-批次管理
     */
    get: (p, c) => $.get("/api/ems/basic/batch/exportForSkillTrain", p, c),
  },
  batch_listBatch: {
    /*
     * 简易批次列表
     * ableStatus 启用状态 (string query )
     * siteType 学校类型 (string query )
     * siteTypes 学校类型列表 (array query )
     */
    get: (p, c) => $.get("/api/ems/basic/batch/listBatch", p, c),
  },
  batch_listForAdult: {
    /*
     * 列表-学历教育-学历配置-批次管理
     */
    get: (p, c) => $.get("/api/ems/basic/batch/listForAdult", p, c),
  },
  batch_listForArmy: {
    /*
     * 列表-中军职达-职业技能培训-基础配置-批次管理
     */
    get: (p, c) => $.get("/api/ems/basic/batch/listForArmy", p, c),
  },
  batch_listForContinue: {
    /*
     * 列表-继续教育-教务配置-批次管理
     */
    get: (p, c) => $.get("/api/ems/basic/batch/listForContinue", p, c),
  },
  batch_listForExemptionDegree: {
    /*
     * 列表-免试专升本-基础配置-批次管理
     */
    get: (p, c) => $.get("/api/ems/basic/batch/listForExemptionDegree", p, c),
  },
  batch_listForSelfTaught: {
    /*
     * 列表-自考平台-基础配置-批次管理
     */
    get: (p, c) => $.get("/api/ems/basic/batch/listForSelfTaught", p, c),
  },
  batch_listForSkillTrain: {
    /*
     * 列表-技能培训-基础配置-批次管理
     */
    get: (p, c) => $.get("/api/ems/basic/batch/listForSkillTrain", p, c),
  },
  batch_listPlatformBatch: {
    /*
     * 根据平台查询简易批次列表
     * ableStatus 启用状态 (string query )
     * platform 平台 (string query )
     */
    get: (p, c) => $.get("/api/ems/basic/batch/listPlatformBatch", p, c),
  },
  batch_upload: {
    /*
     * 批量导入
     * excelFile excelFile (file formData required)
     * platform 平台 (string query required)
     */
    post: (p, c) => $.post("/api/ems/basic/batch/upload", p, c),
  },

  /**
   * 期末考区
   */
  campus: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * continueSiteId 对应继教院学校id (integer query )
     * id  (integer query )
     * name 期末考区名字 (string query )
     * siteId 学校id (integer query )
     * type 类型：期末考区或企业学生期末考点 (string query )
     */
    post: (p, c) => $.post("/api/ems/basic/campus", p, c),
  },
  campus_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/basic/campus/export", p, c),
  },
  campus_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/basic/campus/list", p, c),
  },
  campus_listEnterpriseExamPoint: {
    /*
     * 企业学生期末考点列表
     */
    get: (p, c) => $.get("/api/ems/basic/campus/listEnterpriseExamPoint", p, c),
  },
  campus_listName: {
    /*
     * 考区名字
     * ableStatus 启用禁用 (string query )
     * siteId 学校id (integer query )
     */
    get: (p, c) => $.get("/api/ems/basic/campus/listName", p, c),
  },
  campus_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/basic/campus/upload", p, c),
  },

  /**
   * 和同方
   */
  contractParty: {
    /*
     * 添加
     * id  (integer query )
     * name 合同方名称 (string query )
     * seal 合同章 (string query )
     */
    post: (p, c) => $.post("/api/ems/basic/contractParty", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/basic/contractParty", p, c),
  },
  contractParty_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/basic/contractParty/list", p, c),
  },
  contractParty_listSimple: {
    /*
     * 简易和同方列表
     */
    get: (p, c) => $.get("/api/ems/basic/contractParty/listSimple", p, c),
  },

  /**
   * 专业科类
   */
  discipline: {
    /*
     * 添加
     * batch 批次 (string query required)
     * discipline 科类 (string query required)
     * id id (integer query )
     * majorId majorId (integer query required)
     * siteId siteId (integer query required)
     */
    post: (p, c) => $.post("/api/ems/basic/discipline", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/basic/discipline", p, c),
  },
  discipline_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/basic/discipline/export", p, c),
  },
  discipline_exportForExemptionDegree: {
    /*
     * 导出-免试专升本
     */
    get: (p, c) =>
      $.get("/api/ems/basic/discipline/exportForExemptionDegree", p, c),
  },
  discipline_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/basic/discipline/list", p, c),
  },
  discipline_listForExemptionDegree: {
    /*
     * 列表-免试专升本
     */
    get: (p, c) =>
      $.get("/api/ems/basic/discipline/listForExemptionDegree", p, c),
  },
  discipline_listName: {
    /*
     * 科类名字列表
     * batch 批次 (string query )
     * level 层次:高起专，专升本，高起本 (string query )
     * major 专业 (string query )
     * site 学校 (string query )
     */
    get: (p, c) => $.get("/api/ems/basic/discipline/listName", p, c),
  },
  discipline_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/basic/discipline/upload", p, c),
  },

  /**
   * 成考科目
   */
  disciplineSubjects_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/basic/disciplineSubjects/list", p, c),
  },
  disciplineSubjects_remove: {
    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/basic/disciplineSubjects/remove", p, c),
  },
  disciplineSubjects_save: {
    /*
     * 添加编辑
     * discipline 科类 (string query )
     * id  (integer query )
     * level 层次 (string query )
     * subjects 入学考试科目 (string query )
     */
    post: (p, c) => $.post("/api/ems/basic/disciplineSubjects/save", p, c),
  },

  /**
   * 文件政策配置
   */
  eduFileConfig_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/basic/eduFileConfig/list", p, c),
  },
  eduFileConfig_listCategories: {
    /*
     * 简易分类列表
     * platform 平台 (string query )
     */
    get: (p, c) => $.get("/api/ems/basic/eduFileConfig/listCategories", p, c),
  },
  eduFileConfig_listTypes: {
    /*
     * 简易具体类型列表
     * category 分类 (string query )
     * platform 平台 (string query )
     */
    get: (p, c) => $.get("/api/ems/basic/eduFileConfig/listTypes", p, c),
  },
  eduFileConfig_save: {
    /*
     * 添加编辑
     * category 文件分类 (string query )
     * creatorId  (integer query )
     * id  (integer query )
     * platform 平台 (string query )
     * type 具体类型 (string query )
     */
    post: (p, c) => $.post("/api/ems/basic/eduFileConfig/save", p, c),
  },

  /**
   * 招生简章
   */
  enrollRecruitmentBrochure_export: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/ems/basic/enrollRecruitmentBrochure/export", p, c),
  },
  enrollRecruitmentBrochure_getBySiteId: {
    /*
     * 根据学校ID查询招生简章（H5网页版）
     * siteId siteId (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/basic/enrollRecruitmentBrochure/getBySiteId", p, c),
  },
  enrollRecruitmentBrochure_getBySiteIdForPicture: {
    /*
     * 根据学校ID查询招生简章（图片版）
     * siteId siteId (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/basic/enrollRecruitmentBrochure/getBySiteIdForPicture",
        p,
        c
      ),
  },
  enrollRecruitmentBrochure_getByTypeAndLevel: {
    /*
     * 根据层次查询科类和专业列表
     * level 层次 (string query required)
     * siteType 学校类型:只允许成教 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/basic/enrollRecruitmentBrochure/getByTypeAndLevel", p, c),
  },
  enrollRecruitmentBrochure_list: {
    /*
     * 招生简章列表
     */
    get: (p, c) => $.get("/api/ems/basic/enrollRecruitmentBrochure/list", p, c),
  },
  enrollRecruitmentBrochure_listRecord: {
    /*
     * 历史版本列表
     */
    get: (p, c) =>
      $.get("/api/ems/basic/enrollRecruitmentBrochure/listRecord", p, c),
  },
  enrollRecruitmentBrochure_listSimpleSite: {
    /*
     * 简单学校列表
     */
    get: (p, c) =>
      $.get("/api/ems/basic/enrollRecruitmentBrochure/listSimpleSite", p, c),
  },
  enrollRecruitmentBrochure_remove: {
    /*
     * 批量删除
     * ids 行ID (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/basic/enrollRecruitmentBrochure/remove", p, c),
  },

  /**
   * 线下考点
   */
  examinationCentre_ableClassroom: {
    /*
     * 启用禁用教室
     * ableStatus 启用禁用 (string query required)
     * id id (integer query )
     */
    post: (p, c) =>
      $.post("/api/ems/basic/examinationCentre/ableClassroom", p, c),
  },
  examinationCentre_downloadClassroomMould: {
    /*
     * 下载考场教室导入模版
     */
    get: (p, c) =>
      $.get("/api/ems/basic/examinationCentre/downloadClassroomMould", p, c),
  },
  examinationCentre_downloadMouldCentre: {
    /*
     * 下载线下考点导入模版
     */
    get: (p, c) =>
      $.get("/api/ems/basic/examinationCentre/downloadMouldCentre", p, c),
  },
  examinationCentre_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/basic/examinationCentre/list", p, c),
  },
  examinationCentre_listClassroom: {
    /*
     * 教室列表
     * id 行ID (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/basic/examinationCentre/listClassroom", p, c),
  },
  examinationCentre_listSimple: {
    /*
     * 简单考点列表
     * campus 期末考区 (string query )
     * campusList 期末考区列表 (array query )
     */
    get: (p, c) => $.get("/api/ems/basic/examinationCentre/listSimple", p, c),
  },
  examinationCentre_listSimpleClassroom: {
    /*
     * 简单教室列表
     * ableStatus 启用禁用 (string query )
     * campus 期末考区 (string query )
     * centreId 考点ID (integer query )
     * centreName 考点名称 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/basic/examinationCentre/listSimpleClassroom", p, c),
  },
  examinationCentre_remove: {
    /*
     * 删除线下考点
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/basic/examinationCentre/remove", p, c),
  },
  examinationCentre_removeClassroom: {
    /*
     * 删除教室
     * ids ids (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/basic/examinationCentre/removeClassroom", p, c),
  },
  examinationCentre_save: {
    /*
     * 添加编辑
     * address 具体地址 (string query required)
     * campus 期末考区 (string query required)
     * id id (integer query )
     * name 名称 (string query required)
     */
    post: (p, c) => $.post("/api/ems/basic/examinationCentre/save", p, c),
  },
  examinationCentre_saveClassroom: {
    /*
     * 添加|编辑教室
     * ableStatus 启用禁用 (string query required)
     * capacity 容量 (integer query required)
     * centreId 考点列表ID (integer query required)
     * classroom 教室 (string query required)
     * id 教室列表id (integer query )
     */
    post: (p, c) =>
      $.post("/api/ems/basic/examinationCentre/saveClassroom", p, c),
  },
  examinationCentre_uploadCentre: {
    /*
     * 导入线下考点
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/basic/examinationCentre/uploadCentre", p, c),
  },
  examinationCentre_uploadClassroom: {
    /*
     * 导入考场教室
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/basic/examinationCentre/uploadClassroom", p, c),
  },

  /**
   * 免试专升本-课表
   */
  exemptionDegree_timetable: {
    /*
     * 添加
     * classId 班级 (integer query )
     * endTime 结束时间 (string query )
     * id  (integer query )
     * name 名称 (string query )
     * publishStatus 发布状态 (string query )
     * publishTime 发布时间 (string query )
     * startTime 开始时间 (string query )
     */
    post: (p, c) => $.post("/api/ems/basic/exemptionDegree/timetable", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/basic/exemptionDegree/timetable", p, c),
  },
  exemptionDegree_timetable_exportArrange: {
    /*
     * 导出
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/basic/exemptionDegree/timetable/exportArrange", p, c),
  },
  exemptionDegree_timetable_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/basic/exemptionDegree/timetable/list", p, c),
  },
  exemptionDegree_timetable_listArrange: {
    /*
     * 安排列表
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/basic/exemptionDegree/timetable/listArrange", p, c),
  },
  exemptionDegree_timetable_listForClient: {
    /*
     * c端我的课表
     */
    get: (p, c) =>
      $.get("/api/ems/basic/exemptionDegree/timetable/listForClient", p, c),
  },
  exemptionDegree_timetable_publish: {
    /*
     * 发布
     * id id (integer query required)
     * publishStatus 发布状态 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/basic/exemptionDegree/timetable/publish", p, c),
  },
  exemptionDegree_timetable_removeArrange: {
    /*
     * 删除安排
     * ids 安排记录返回的ids (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/basic/exemptionDegree/timetable/removeArrange", p, c),
  },
  exemptionDegree_timetable_saveArrange: {
    /*
     * 添加编辑安排
     * classroom 上课地点 (string query required)
     * courseId 课程ID (integer query required)
     * displayName 显示名称 (string query required)
     * endTime 结束时间 (string query required)
     * id 安排记录返回的id (integer query )
     * remark 备注 (string query )
     * startTime 开始时间 (string query required)
     * teacher 授课老师 (string query required)
     * timeTableId 课表ID(不可编辑) (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/basic/exemptionDegree/timetable/saveArrange", p, c),
  },
  exemptionDegree_timetable_uploadArrange: {
    /*
     * 导入课表安排
     * excelFile excelFile (file formData required)
     * id id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/basic/exemptionDegree/timetable/uploadArrange", p, c),
  },

  /**
   * 免试专升本志愿
   */
  exemptionDegreeChoice: {
    /*
     * 添加
     * ableStatus 启用禁用 (string query )
     * campus 就读校区 (string query )
     * discipline 科类 (string query )
     * examStandard 考查标准 (string query )
     * id  (integer query )
     * major 专业 (string query )
     * planEnrollCount 计划招生数 (integer query )
     * siteId 免试专升本学校ID (integer query )
     * tuitionStandard 学费标准 (string query )
     */
    post: (p, c) => $.post("/api/ems/basic/exemptionDegreeChoice", p, c),
  },
  exemptionDegreeChoice_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/basic/exemptionDegreeChoice/export", p, c),
  },
  exemptionDegreeChoice_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/basic/exemptionDegreeChoice/list", p, c),
  },
  exemptionDegreeChoice_listSimple: {
    /*
     * 简易列表
     * ableStatus 启用状态 (string query )
     * discipline 科类 (string query )
     * juniorMajor 前置专业 (string query )
     * site 学校 (string query )
     * siteId 学校ID (integer query )
     */
    get: (p, c) =>
      $.get("/api/ems/basic/exemptionDegreeChoice/listSimple", p, c),
  },
  exemptionDegreeChoice_listSimpleByMajorDiscipline: {
    /*
     * 简易列表, 根据前置专业和科类查询
     * ableStatus 启用状态 (string query )
     * discipline 科类 (string query )
     * juniorMajor 前置专业 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/ems/basic/exemptionDegreeChoice/listSimpleByMajorDiscipline",
        p,
        c
      ),
  },
  exemptionDegreeChoice_repair: {
    /*
     * 修复数据
     */
    post: (p, c) => $.post("/api/ems/basic/exemptionDegreeChoice/repair", p, c),
  },
  exemptionDegreeChoice_upload: {
    /*
     * 批量导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/basic/exemptionDegreeChoice/upload", p, c),
  },

  /**
   * 免试专升本-班级
   */
  exemptionDegreeClass: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * headerTeacherId 班主任 (integer query )
     * id  (integer query )
     * name 名称 (string query )
     */
    post: (p, c) => $.post("/api/ems/basic/exemptionDegreeClass", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/basic/exemptionDegreeClass", p, c),
  },
  exemptionDegreeClass_assignClass: {
    /*
     * 分配班级-服务学生管理
     * classId 班级ID (integer query )
     * schoolRollIds 合同编号IDS (array query required)
     */
    post: (p, c) =>
      $.post("/api/ems/basic/exemptionDegreeClass/assignClass", p, c),
  },
  exemptionDegreeClass_downloadMould: {
    /*
     * 下载模板
     */
    get: (p, c) =>
      $.get("/api/ems/basic/exemptionDegreeClass/downloadMould", p, c),
  },
  exemptionDegreeClass_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/basic/exemptionDegreeClass/export", p, c),
  },
  exemptionDegreeClass_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/basic/exemptionDegreeClass/list", p, c),
  },
  exemptionDegreeClass_listSimple: {
    /*
     * 简易班级列表
     * ableStatus 启用状态 (string query )
     * headerTeacherId 班主任ID (integer query )
     */
    get: (p, c) =>
      $.get("/api/ems/basic/exemptionDegreeClass/listSimple", p, c),
  },
  exemptionDegreeClass_listStudent: {
    /*
     * 班级学生列表
     * classId 班级ID (integer query )
     */
    get: (p, c) =>
      $.get("/api/ems/basic/exemptionDegreeClass/listStudent", p, c),
  },
  exemptionDegreeClass_removeStudent: {
    /*
     * 移除学生
     * id id (integer query required)
     * schoolRollId 合同编号 (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/basic/exemptionDegreeClass/removeStudent", p, c),
  },
  exemptionDegreeClass_saveStudent: {
    /*
     * 添加单个学生
     * id id (integer query required)
     * schoolRollId 合同编号 (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/basic/exemptionDegreeClass/saveStudent", p, c),
  },
  exemptionDegreeClass_uploadStudent: {
    /*
     * 批量导入班级学生
     * excelFile excelFile (file formData required)
     * id id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/basic/exemptionDegreeClass/uploadStudent", p, c),
  },

  /**
   * 免试专升本学校
   */
  exemptionDegreeSite: {
    /*
     * 添加
     * ableStatus 启用禁用 (string query )
     * category 分类 (string query )
     * id  (integer query )
     * intro 介绍 (string query )
     * logo logo (string query )
     * name 学校 (string query )
     * province 省份 (string query )
     */
    post: (p, c) => $.post("/api/ems/basic/exemptionDegreeSite", p, c),
  },
  exemptionDegreeSite_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/basic/exemptionDegreeSite/export", p, c),
  },
  exemptionDegreeSite_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/basic/exemptionDegreeSite/list", p, c),
  },
  exemptionDegreeSite_listName: {
    /*
     * 简易名称列表
     * ableStatus 启用状态 (string query )
     * category 分类 (string query )
     * province 省份 (string query )
     */
    get: (p, c) => $.get("/api/ems/basic/exemptionDegreeSite/listName", p, c),
  },
  exemptionDegreeSite_listSimple: {
    /*
     * 简易列表
     * ableStatus 启用状态 (string query )
     * category 分类 (string query )
     * province 省份 (string query )
     */
    get: (p, c) => $.get("/api/ems/basic/exemptionDegreeSite/listSimple", p, c),
  },
  exemptionDegreeSite_upload: {
    /*
     * 批量导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/basic/exemptionDegreeSite/upload", p, c),
  },

  /**
   * 免试专升本教师
   */
  exemptionDegreeTeacher: {
    /*
     * 添加
     * ableStatus 启用禁用 (string query )
     * adminId  (integer query )
     * avatar 头像 (string query )
     * displayName 学生端显示名称 (string query )
     * id  (integer query )
     * intro 简介 (string query )
     * name 姓名 (string query )
     */
    post: (p, c) => $.post("/api/ems/basic/exemptionDegreeTeacher", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/basic/exemptionDegreeTeacher", p, c),
  },
  exemptionDegreeTeacher_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/basic/exemptionDegreeTeacher/export", p, c),
  },
  exemptionDegreeTeacher_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/basic/exemptionDegreeTeacher/list", p, c),
  },
  exemptionDegreeTeacher_listSimple: {
    /*
     * 简易列表
     * ableStatus 启用状态 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/basic/exemptionDegreeTeacher/listSimple", p, c),
  },

  /**
   * 行业合同
   */
  industryContract: {
    /*
     * 添加
     * batch 批次 (string query )
     * contractAdminId 甲方负责人id (integer query )
     * contractId 甲方 (integer query )
     * cooperationId 行业合作id (integer query )
     * id  (integer query )
     * overDue 是否超期 (string query )
     * protocol 协议 (string query )
     * signPeriod 签署期限 (string query )
     * signTime 签署时间 (string query )
     * signYear 签署年份 (string query )
     */
    post: (p, c) => $.post("/api/ems/basic/industryContract", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/basic/industryContract", p, c),
  },
  industryContract_export: {
    /*
     * 导出
     * id 行业合作id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/basic/industryContract/export", p, c),
  },
  industryContract_list: {
    /*
     * 列表
     * id 行业合作id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/basic/industryContract/list", p, c),
  },

  /**
   * 行业合作
   */
  industryCooperation: {
    /*
     * 添加
     * adminId 管理员id (integer query )
     * id  (integer query )
     * name 名称 (string query )
     * principal 负责人 (string query )
     */
    post: (p, c) => $.post("/api/ems/basic/industryCooperation", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/basic/industryCooperation", p, c),
  },
  industryCooperation_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/basic/industryCooperation/export", p, c),
  },
  industryCooperation_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/basic/industryCooperation/list", p, c),
  },
  industryCooperation_resetPassword: {
    /*
     * 重置密码
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/basic/industryCooperation/resetPassword", p, c),
  },

  /**
   * 志愿查询(免试专升本)
   */
  juniorMajor: {
    /*
     * 添加编辑
     * choiceId 可报志愿 (integer query )
     * discipline 科类 (string query )
     * id  (integer query )
     * name 名称 (string query )
     */
    post: (p, c) => $.post("/api/ems/basic/juniorMajor", p, c),

    /*
     * 批量删除
     * ids ids (array query required)
     */
    delete: (p, c) => $.delete("/api/ems/basic/juniorMajor", p, c),
  },
  juniorMajor_downloadMould: {
    /*
     * 下载模版
     */
    get: (p, c) => $.get("/api/ems/basic/juniorMajor/downloadMould", p, c),
  },
  juniorMajor_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/basic/juniorMajor/export", p, c),
  },
  juniorMajor_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/basic/juniorMajor/list", p, c),
  },
  juniorMajor_listDiscipline: {
    /*
     * 科类列表
     */
    get: (p, c) => $.get("/api/ems/basic/juniorMajor/listDiscipline", p, c),
  },
  juniorMajor_listMajor: {
    /*
     * 专业列表
     * discipline 科类 (string query )
     */
    get: (p, c) => $.get("/api/ems/basic/juniorMajor/listMajor", p, c),
  },
  juniorMajor_listSimple: {
    /*
     * 简易列表--即将删除
     * discipline 科类 (string query )
     */
    get: (p, c) => $.get("/api/ems/basic/juniorMajor/listSimple", p, c),
  },
  juniorMajor_search: {
    /*
     * 后端查询
     * juniorMajorName 专科专业名称 (string query required)
     */
    post: (p, c) => $.post("/api/ems/basic/juniorMajor/search", p, c),
  },
  juniorMajor_searchByClient: {
    /*
     * C端查询
     * juniorMajorName 专科专业名称 (string query required)
     */
    post: (p, c) => $.post("/api/ems/basic/juniorMajor/searchByClient", p, c),
  },
  juniorMajor_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/basic/juniorMajor/upload", p, c),
  },

  /**
   * 专业
   */
  major: {
    /*
     * 添加
     * ableStatus 启用状态:启用,禁用 (string query )
     * allFee  (number query )
     * beforeTutorFee 考前辅导费 (number query )
     * collectingBeforeTutorFee 代收考前辅导费（上交学校部分） (number query )
     * collectingTutorFee 代收辅导费（上交学校部分） (number query )
     * discipline 科类 (string query )
     * fifthFee 第五次学费 (number query )
     * fifthTutorFee 第五次辅导费 (number query )
     * firstFee 第一次学费 (number query )
     * firstTutorFee 第一次辅导费 (number query )
     * fourthFee 第四次学费 (number query )
     * fourthTutorFee 第四次辅导费 (number query )
     * id  (integer query )
     * level 层次:高起专,专升本,高起本 (string query )
     * name 专业名字 (string query )
     * period  (integer query )
     * remark 备注 (string query )
     * schoolingLength 学制 (number query )
     * secondFee 第二次学费 (number query )
     * secondTutorFee 第二次辅导费 (number query )
     * siteId 学校id (integer query )
     * studyType 学习类型:函授,业余,网络教育 (string query )
     * thirdFee 第三次学费 (number query )
     * thirdTutorFee 第三次辅导费 (number query )
     * tutorFee 辅导费 (number query )
     */
    post: (p, c) => $.post("/api/ems/basic/major", p, c),
  },
  major_downloadMould: {
    /*
     * 下载模板
     */
    get: (p, c) => $.get("/api/ems/basic/major/downloadMould", p, c),
  },
  major_exemptionCourse_downloadMould: {
    /*
     * 下载模板
     */
    get: (p, c) =>
      $.get("/api/ems/basic/major/exemptionCourse/downloadMould", p, c),
  },
  major_exemptionCourse_linkRequiredCourse: {
    /*
     * 批量关联必修课
     * choiceIds 志愿ids (array query required)
     * courseIds 课程ids (array query )
     */
    post: (p, c) =>
      $.post("/api/ems/basic/major/exemptionCourse/linkRequiredCourse", p, c),
  },
  major_exemptionCourse_listSimpleCourse: {
    /*
     * 简易课程列表
     * ableStatus 启用状态 (string query )
     * choiceId 志愿id，不传取所有 (integer query )
     * courseType 课程类型:必修课|专业课 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/basic/major/exemptionCourse/listSimpleCourse", p, c),
  },
  major_exemptionCourse_remove: {
    /*
     * 删除志愿课程关联
     * ids ids (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/basic/major/exemptionCourse/remove", p, c),
  },
  major_exemptionCourse_save: {
    /*
     * 添加编辑
     * ableStatus 启用状态 (string query )
     * choiceId 志愿ID (integer query )
     * courseId 课程ID (integer query )
     * id  (integer query )
     */
    post: (p, c) => $.post("/api/ems/basic/major/exemptionCourse/save", p, c),
  },
  major_exemptionCourse_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/basic/major/exemptionCourse/upload", p, c),
  },
  major_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/basic/major/export", p, c),
  },
  major_exportForArmySkill: {
    /*
     * 导出退伍军人技能培训专业
     */
    get: (p, c) => $.get("/api/ems/basic/major/exportForArmySkill", p, c),
  },
  major_exportForContinue: {
    /*
     * 导出继教院专业
     */
    get: (p, c) => $.get("/api/ems/basic/major/exportForContinue", p, c),
  },
  major_exportForExemptionDegree: {
    /*
     * 导出免试专升本专业
     */
    get: (p, c) => $.get("/api/ems/basic/major/exportForExemptionDegree", p, c),
  },
  major_exportForSelfTaught: {
    /*
     * 导出自考专业
     */
    get: (p, c) => $.get("/api/ems/basic/major/exportForSelfTaught", p, c),
  },
  major_exportForSkillTrain: {
    /*
     * 导出技能培训专业
     */
    get: (p, c) => $.get("/api/ems/basic/major/exportForSkillTrain", p, c),
  },
  major_list: {
    /*
     * 列表(学历教育)
     */
    get: (p, c) => $.get("/api/ems/basic/major/list", p, c),
  },
  major_listForArmySkill: {
    /*
     * 退伍军人技能培训专业列表
     */
    get: (p, c) => $.get("/api/ems/basic/major/listForArmySkill", p, c),
  },
  major_listForContinue: {
    /*
     * 继教院专业列表
     */
    get: (p, c) => $.get("/api/ems/basic/major/listForContinue", p, c),
  },
  major_listForExemptionDegree: {
    /*
     * 免试专升本列表
     */
    get: (p, c) => $.get("/api/ems/basic/major/listForExemptionDegree", p, c),
  },
  major_listForSelfTaught: {
    /*
     * 自考专业列表
     */
    get: (p, c) => $.get("/api/ems/basic/major/listForSelfTaught", p, c),
  },
  major_listForSkillTrain: {
    /*
     * 技能培训专业列表
     */
    get: (p, c) => $.get("/api/ems/basic/major/listForSkillTrain", p, c),
  },
  major_listLevel: {
    /*
     * listLevel
     * siteId 学校id (integer query )
     */
    get: (p, c) => $.get("/api/ems/basic/major/listLevel", p, c),
  },
  major_listName: {
    /*
     * 名字列表
     * ableStatus 启用状态 (string query )
     * level 层次:高起专，专升本，高起本 (string query )
     * site 学校 (string query )
     */
    get: (p, c) => $.get("/api/ems/basic/major/listName", p, c),
  },
  major_listSelfSimple: {
    /*
     * 自考简易列表
     */
    get: (p, c) => $.get("/api/ems/basic/major/listSelfSimple", p, c),
  },
  major_listSimple: {
    /*
     * 简易列表
     * ableStatus 启用状态 (string query )
     * level 层次:高起专，专升本，高起本 (string query )
     * site 学校 (string query )
     * siteId 学校id (integer query )
     * siteType 学校 (string query )
     */
    get: (p, c) => $.get("/api/ems/basic/major/listSimple", p, c),
  },
  major_listSimpleForExemptionDegree: {
    /*
     * 免试专升本专业简易列表
     * ableStatus 启用状态 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/basic/major/listSimpleForExemptionDegree", p, c),
  },
  major_listSimpleForSelfTaught: {
    /*
     * 自考专业简易列表
     * ableStatus 启用状态 (string query )
     * level 层次 (string query )
     */
    get: (p, c) => $.get("/api/ems/basic/major/listSimpleForSelfTaught", p, c),
  },
  major_listSimpleValueForExemptionDegree: {
    /*
     * 免试专升本专业简易列表
     * ableStatus 启用状态 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/basic/major/listSimpleValueForExemptionDegree", p, c),
  },
  major_publishBrochure: {
    /*
     * 发布招生简章
     * content 更新说明 (string query )
     * provinces 省份，多选 (array query )
     * sendDingFlag 是否发送ding通知 (string query )
     * siteTypes 学校类型，多选 (array query )
     */
    put: (p, c) => $.put("/api/ems/basic/major/publishBrochure", p, c),
  },
  major_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/basic/major/upload", p, c),
  },
  major_uploadForArmySkill: {
    /*
     * 导入退伍军人技能培训专业
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/basic/major/uploadForArmySkill", p, c),
  },
  major_uploadForContinue: {
    /*
     * 导入继教院专业
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/ems/basic/major/uploadForContinue", p, c),
  },
  major_uploadForExemptionDegree: {
    /*
     * 导入免试专升本专业
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/basic/major/uploadForExemptionDegree", p, c),
  },
  major_uploadForSelfTaught: {
    /*
     * 导入自考专业
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/basic/major/uploadForSelfTaught", p, c),
  },
  major_uploadForSkillTrain: {
    /*
     * 导入退伍军人技能培训专业
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/basic/major/uploadForSkillTrain", p, c),
  },

  /**
   * 自考专业课程配置
   */
  majorCourse: {
    /*
     * 添加
     * courseId 课程ID (integer query )
     * credits 学分 (number query )
     * helpful 是否有助学 (string query )
     * id  (integer query )
     * majorId 专业ID (integer query )
     * plan 计划 (string query )
     * practiceCredits 实践学分 (number query )
     * practiceFlag 是否实践课 (string query )
     * theoryCredits 理论学分 (number query )
     * type 课程类型 (string query )
     */
    post: (p, c) => $.post("/api/ems/basic/majorCourse", p, c),
  },
  majorCourse_downloadMould: {
    /*
     * 下载模板
     */
    get: (p, c) => $.get("/api/ems/basic/majorCourse/downloadMould", p, c),
  },
  majorCourse_getMajorIdByCourseId: {
    /*
     * 根据课程id获取专业id
     * courseIds 课程id (array query required)
     * majorId 专业id (integer query required)
     * siteId 学校id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/basic/majorCourse/getMajorIdByCourseId", p, c),
  },
  majorCourse_listBySchoolRollId: {
    /*
     * 根据合同获取简易列表
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/basic/majorCourse/listBySchoolRollId", p, c),
  },
  majorCourse_listContinueCourseInfo: {
    /*
     * 职教生课程信息
     */
    get: (p, c) =>
      $.get("/api/ems/basic/majorCourse/listContinueCourseInfo", p, c),
  },
  majorCourse_listCourseForClient: {
    /*
     * C端自考课程列表
     */
    get: (p, c) =>
      $.get("/api/ems/basic/majorCourse/listCourseForClient", p, c),
  },
  majorCourse_listCourseName: {
    /*
     * 获取课程名称
     */
    get: (p, c) => $.get("/api/ems/basic/majorCourse/listCourseName", p, c),
  },
  majorCourse_listSimple: {
    /*
     * 根据专业id自考课程列表
     * ableStatus 启用状态 (string query )
     * majorId 专业id (integer query required)
     * plan 计划 (string query )
     */
    get: (p, c) => $.get("/api/ems/basic/majorCourse/listSimple", p, c),
  },
  majorCourse_listSimpleCourse: {
    /*
     * 自考课程简易列表
     * ableStatus 启用状态 (string query )
     * majorId 专业id (integer query required)
     * plan 计划 (string query )
     */
    get: (p, c) => $.get("/api/ems/basic/majorCourse/listSimpleCourse", p, c),
  },
  majorCourse_remove: {
    /*
     * 删除专业课程关联
     * ids majorCourseIds (array query required)
     */
    delete: (p, c) => $.delete("/api/ems/basic/majorCourse/remove", p, c),
  },
  majorCourse_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/basic/majorCourse/upload", p, c),
  },

  /**
   * 专业学位配置
   */
  majorDegreeConfig: {
    /*
     * 添加编辑
     * ableStatus 启用状态 (string query )
     * conditionName 条件 (string query )
     * conditionValue 条件值 (number query )
     * id  (integer query )
     * majorId 专业ID (integer query )
     * type 类型：平均分|单科分数 (string query )
     */
    post: (p, c) => $.post("/api/ems/basic/majorDegreeConfig", p, c),
  },
  majorDegreeConfig_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/basic/majorDegreeConfig/export", p, c),
  },
  majorDegreeConfig_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/basic/majorDegreeConfig/list", p, c),
  },

  /**
   * 学籍状态配置
   */
  schoolStatus_config: {
    /*
     * 添加编辑
     * ableStatus 启用状态 (string query )
     * id  (integer query )
     * schoolStatus 学籍状态 (string query )
     * siteType 学校类型 (string query )
     */
    post: (p, c) => $.post("/api/ems/basic/schoolStatus/config", p, c),

    /*
     * 删除, 学生数量为0的才可以删
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/basic/schoolStatus/config", p, c),
  },
  schoolStatus_config_exportForAdult: {
    /*
     * 导出-学历教育-学历配置-学籍状态管理
     */
    get: (p, c) =>
      $.get("/api/ems/basic/schoolStatus/config/exportForAdult", p, c),
  },
  schoolStatus_config_exportForArmy: {
    /*
     * 导出-中军职达-职业技能培训-基础配置-学籍状态管理
     */
    get: (p, c) =>
      $.get("/api/ems/basic/schoolStatus/config/exportForArmy", p, c),
  },
  schoolStatus_config_exportForContinue: {
    /*
     * 导出-继续教育-教务配置-学籍状态管理
     */
    get: (p, c) =>
      $.get("/api/ems/basic/schoolStatus/config/exportForContinue", p, c),
  },
  schoolStatus_config_exportForExemptionDegree: {
    /*
     * 导出-免试专升本-学历配置-学籍状态管理
     */
    get: (p, c) =>
      $.get(
        "/api/ems/basic/schoolStatus/config/exportForExemptionDegree",
        p,
        c
      ),
  },
  schoolStatus_config_exportForSelfTaught: {
    /*
     * 导出-自考平台-基础配置-学籍状态管理
     */
    get: (p, c) =>
      $.get("/api/ems/basic/schoolStatus/config/exportForSelfTaught", p, c),
  },
  schoolStatus_config_listForAdult: {
    /*
     * 列表-学历教育-学历配置-学籍状态管理
     */
    get: (p, c) =>
      $.get("/api/ems/basic/schoolStatus/config/listForAdult", p, c),
  },
  schoolStatus_config_listForArmy: {
    /*
     * 列表-中军职达-职业技能培训-基础配置-学籍状态管理
     */
    get: (p, c) =>
      $.get("/api/ems/basic/schoolStatus/config/listForArmy", p, c),
  },
  schoolStatus_config_listForContinue: {
    /*
     * 列表-继续教育-教务配置-学籍状态管理
     */
    get: (p, c) =>
      $.get("/api/ems/basic/schoolStatus/config/listForContinue", p, c),
  },
  schoolStatus_config_listForExemptionDegree: {
    /*
     * 列表-免试专升本-基础配置-学籍状态管理
     */
    get: (p, c) =>
      $.get("/api/ems/basic/schoolStatus/config/listForExemptionDegree", p, c),
  },
  schoolStatus_config_listForSelfTaught: {
    /*
     * 列表-自考平台-基础配置-学籍状态管理
     */
    get: (p, c) =>
      $.get("/api/ems/basic/schoolStatus/config/listForSelfTaught", p, c),
  },
  schoolStatus_config_listSchoolStatus: {
    /*
     * 学籍状态列表
     * ableStatus 启用状态 (string query )
     * siteType 学校类型 (string query )
     * siteTypes 学校类型列表 (array query )
     */
    get: (p, c) =>
      $.get("/api/ems/basic/schoolStatus/config/listSchoolStatus", p, c),
  },
  schoolStatus_config_upload: {
    /*
     * 批量导入
     * excelFile excelFile (file formData required)
     * platform 平台 (string query required)
     */
    post: (p, c) => $.post("/api/ems/basic/schoolStatus/config/upload", p, c),
  },
  schoolStatus_pipeline_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/basic/schoolStatus/pipeline/export", p, c),
  },
  schoolStatus_pipeline_list: {
    /*
     * 列表-学历教育-学历配置
     */
    get: (p, c) => $.get("/api/ems/basic/schoolStatus/pipeline/list", p, c),
  },
  schoolStatus_pipeline_remove: {
    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/basic/schoolStatus/pipeline/remove", p, c),
  },
  schoolStatus_pipeline_save: {
    /*
     * 添加编辑
     * id  (integer query )
     * siteType 学校类型 (string query )
     * sourceSchoolStatus 来源学籍状态 (string query )
     * targetSchoolStatus 目标学籍状态 (string query )
     */
    post: (p, c) => $.post("/api/ems/basic/schoolStatus/pipeline/save", p, c),
  },
  schoolStatus_pipeline_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/basic/schoolStatus/pipeline/upload", p, c),
  },

  /**
   * 自考毕业要求
   */
  selfTaughtGradRequire: {
    /*
     * 添加
     * commonCredits 公共课学分要求 (number query )
     * coreCount 必修课门数要求 (integer query )
     * coreCredits 必修课学分要求 (number query )
     * electiveCount 选修课门数要求 (integer query )
     * electiveCredits 选修课学分要求 (number query )
     * id  (integer query )
     * majorId 专业id (integer query )
     * plan 计划 (string query )
     */
    post: (p, c) => $.post("/api/ems/basic/selfTaughtGradRequire", p, c),
  },
  selfTaughtGradRequire_downloadMould: {
    /*
     * 下载模板
     */
    get: (p, c) =>
      $.get("/api/ems/basic/selfTaughtGradRequire/downloadMould", p, c),
  },
  selfTaughtGradRequire_getByMajorAndPlan: {
    /*
     * 根据专业和计划获取
     * majorId 专业id (integer query required)
     * plan 计划：新计划、老计划 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/basic/selfTaughtGradRequire/getByMajorAndPlan", p, c),
  },
  selfTaughtGradRequire_upload: {
    /*
     * 导入
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/ems/basic/selfTaughtGradRequire/upload", p, c),
  },

  /**
   * 学校
   */
  site: {
    /*
     * 添加
     * ableStatus 启用状态:启用,禁用 (string query )
     * businessType 业务类型:自营,代理,托管 (string query )
     * degreeCertificateUrl 学位证书模板 (string query )
     * domain 域名 (string query )
     * eduTeacherId 招办老师id (integer query )
     * examCode 线下排考编码 (string query )
     * graduationCertificateUrl 毕业证书模板 (string query )
     * id  (integer query )
     * intro 学校介绍 (string query )
     * logo LOGO (string query )
     * maxSuspendTimes 最大休学次数 (integer query )
     * name 学校名字 (string query )
     * nameEn 英文名 (string query )
     * photo 学校照片 (string query )
     * platformUrl 学习平台地址 (string query )
     * province 省 (string query )
     * remark 备注 (string query )
     * schoolRollReservedYears 学籍保留年份 (number query )
     * schoolRollTeacherId 学籍老师id (integer query )
     * simpleName 学校简称 (string query )
     * thesisDuplicateCheckingSource 论文查重库 (string query )
     * thesisExtraFile 毕业论文模板附件 (string query )
     * thesisNeedTitleReport 论文选题是否提交开题报告 (string query )
     * thesisPassedDuplicatePer 论文查重率通过线(需要学位） (number query )
     * thesisWithoutDegreePassedDuplicatePer 论文查重率通过线（无需学位） (number query )
     * type 类型:成教,远程,国开,全日制,自考 (string query )
     */
    post: (p, c) => $.post("/api/ems/basic/site", p, c),
  },
  site_export: {
    /*
     * 导出(学历教育)
     */
    get: (p, c) => $.get("/api/ems/basic/site/export", p, c),
  },
  site_exportForArmySkill: {
    /*
     * 导出退伍军人技能培训学校列表
     */
    get: (p, c) => $.get("/api/ems/basic/site/exportForArmySkill", p, c),
  },
  site_exportForContinue: {
    /*
     * 导出继教院学校列表
     */
    get: (p, c) => $.get("/api/ems/basic/site/exportForContinue", p, c),
  },
  site_exportForExemptionDegree: {
    /*
     * 导出免试专升本学校列表
     */
    get: (p, c) => $.get("/api/ems/basic/site/exportForExemptionDegree", p, c),
  },
  site_exportForSelfTaught: {
    /*
     * 导出自考学校列表
     */
    get: (p, c) => $.get("/api/ems/basic/site/exportForSelfTaught", p, c),
  },
  site_exportForSkillTrain: {
    /*
     * 导出技能培训学校列表
     */
    get: (p, c) => $.get("/api/ems/basic/site/exportForSkillTrain", p, c),
  },
  site_getByDomain: {
    /*
     * 根据域名获取学校信息
     * domain 域名 (string query required)
     */
    get: (p, c) => $.get("/api/ems/basic/site/getByDomain", p, c),
  },
  site_getById: {
    /*
     * 根据id获取学校信息
     * id 学校ID (integer query required)
     */
    get: (p, c) => $.get("/api/ems/basic/site/getById", p, c),
  },
  site_getTeacherBySite: {
    /*
     * 根据学校和角色查询对应老师
     * role 角色(招办老师|学籍老师|考务老师|教学老师) (string query )
     * siteId 学校ID (integer query required)
     */
    get: (p, c) => $.get("/api/ems/basic/site/getTeacherBySite", p, c),
  },
  site_list: {
    /*
     * 列表(学历教育)
     */
    get: (p, c) => $.get("/api/ems/basic/site/list", p, c),
  },
  site_listContinueSimple: {
    /*
     * 职教学校简易列表
     */
    get: (p, c) => $.get("/api/ems/basic/site/listContinueSimple", p, c),
  },
  site_listForArmySkill: {
    /*
     * 退伍军人技能培训学校列表
     */
    get: (p, c) => $.get("/api/ems/basic/site/listForArmySkill", p, c),
  },
  site_listForContinue: {
    /*
     * 继教院学校列表
     */
    get: (p, c) => $.get("/api/ems/basic/site/listForContinue", p, c),
  },
  site_listForExemptionDegree: {
    /*
     * 免试专升本学校列表
     */
    get: (p, c) => $.get("/api/ems/basic/site/listForExemptionDegree", p, c),
  },
  site_listForSelfTaught: {
    /*
     * 自考学校列表
     */
    get: (p, c) => $.get("/api/ems/basic/site/listForSelfTaught", p, c),
  },
  site_listForSkillTrain: {
    /*
     * 技能培训学校列表
     */
    get: (p, c) => $.get("/api/ems/basic/site/listForSkillTrain", p, c),
  },
  site_listName: {
    /*
     * 学校名字列表
     * province 省份 (string query )
     * type 类型 (string query )
     * types 类型 (array query )
     */
    get: (p, c) => $.get("/api/ems/basic/site/listName", p, c),
  },
  site_listNameByClass: {
    /*
     * 根据班型获取可报名的学校列表
     * className 班型, 免试专升本班型 (string query )
     */
    get: (p, c) => $.get("/api/ems/basic/site/listNameByClass", p, c),
  },
  site_listNameByReceptionTeacher: {
    /*
     * 高校对接人学校名称列表(现改为学籍老师2025-11-19)
     */
    get: (p, c) =>
      $.get("/api/ems/basic/site/listNameByReceptionTeacher", p, c),
  },
  site_listNameByType: {
    /*
     * 根据类型查询学校名字列表
     * province 省份 (string query )
     * type 类型，成教远程国开等 (string query )
     */
    get: (p, c) => $.get("/api/ems/basic/site/listNameByType", p, c),
  },
  site_listProvince: {
    /*
     * 学校省份列表
     * ableStatus 启用状态 (string query )
     * type 学校类型 (string query )
     */
    get: (p, c) => $.get("/api/ems/basic/site/listProvince", p, c),
  },
  site_listSimple: {
    /*
     * 简易列表
     * ableStatus 启用状态 (string query )
     * province 省份 (string query )
     * type 类型:成教,远程,国开,全日制 (string query )
     * types 类型 (array query )
     */
    get: (p, c) => $.get("/api/ems/basic/site/listSimple", p, c),
  },
  site_listSimpleByIds: {
    /*
     * 根据学校id获取简易列表
     * siteIds 学校id列表 (array query required)
     */
    get: (p, c) => $.get("/api/ems/basic/site/listSimpleByIds", p, c),
  },
  site_listSimpleByRollAndType: {
    /*
     * 根据角色和学校类型获取简易列表
     * ableStatus 启用状态 (string query )
     * roll 角色：招办老师、学籍老师 (string query required)
     * type 学校类型 (string query )
     */
    get: (p, c) => $.get("/api/ems/basic/site/listSimpleByRollAndType", p, c),
  },
  site_listType: {
    /*
     * 学校类型列表
     * platform 平台 (string query )
     */
    get: (p, c) => $.get("/api/ems/basic/site/listType", p, c),
  },
  site_refreshSiteDomain: {
    /*
     * 刷新学校域名
     */
    put: (p, c) => $.put("/api/ems/basic/site/refreshSiteDomain", p, c),
  },
  site_transferTeacher: {
    /*
     * 高校老师移交
     * originTeacherId 类型：原老师id (integer query required)
     * teacherId 类型：现老师id (integer query required)
     * type 类型：通过系统配置-学校老师类型获取 (string query required)
     */
    put: (p, c) => $.put("/api/ems/basic/site/transferTeacher", p, c),
  },
  site_upload: {
    /*
     * 导入(学历教育)
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/basic/site/upload", p, c),
  },
  site_uploadForArmySkill: {
    /*
     * 导入中军学校
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/basic/site/uploadForArmySkill", p, c),
  },
  site_uploadForContinue: {
    /*
     * 导入继教院学校
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/ems/basic/site/uploadForContinue", p, c),
  },
  site_uploadForExemptionDegree: {
    /*
     * 导入免试专升本学校
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/basic/site/uploadForExemptionDegree", p, c),
  },
  site_uploadForSelfTaught: {
    /*
     * 导入自考学校
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/basic/site/uploadForSelfTaught", p, c),
  },
  site_uploadForSkillTrain: {
    /*
     * 导入技能培训学校
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/basic/site/uploadForSkillTrain", p, c),
  },

  /**
   * 学校审核配置
   */
  siteConfig_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/basic/siteConfig/export", p, c),
  },
  siteConfig_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/basic/siteConfig/list", p, c),
  },
  siteConfig_save: {
    /*
     * 添加
     * auditAdminId 指定人 (integer query required)
     * businessDepartmentId 事业部ID (integer query required)
     * siteId 学校ID (integer query )
     * type 类型：招办审核、分配班主任 (string query required)
     */
    post: (p, c) => $.post("/api/ems/basic/siteConfig/save", p, c),
  },
  siteConfig_update: {
    /*
     * 编辑指定人
     * auditAdminId 指定人ID (integer query required)
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/basic/siteConfig/update", p, c),
  },
  siteConfig_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/basic/siteConfig/upload", p, c),
  },

  /**
   * 异动配置
   */
  transactionConfig: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * applyPosition 发起方角色：全部，前端，后端 (string query )
     * batch 批次 (string query )
     * id  (integer query )
     * rollGrade 学籍年级 (string query )
     * schoolStatus 学籍状态（多选） (string query )
     * siteId 学校 (integer query )
     * tradeType 异动类型：不读，转校转专业，转批次，休学，退学，转专业，复学 (string query )
     * type 异动分类：招办异动，教务异动 (string query )
     */
    post: (p, c) => $.post("/api/ems/basic/transactionConfig", p, c),

    /*
     * 删除
     * ids ids (array query required)
     */
    delete: (p, c) => $.delete("/api/ems/basic/transactionConfig", p, c),
  },
  transactionConfig_exportAdultBatchOnceRoster: {
    /*
     * 导出成教单次转批次名单
     */
    get: (p, c) =>
      $.get(
        "/api/ems/basic/transactionConfig/exportAdultBatchOnceRoster",
        p,
        c
      ),
  },
  transactionConfig_exportForAdult: {
    /*
     * 导出-学历教育
     */
    get: (p, c) =>
      $.get("/api/ems/basic/transactionConfig/exportForAdult", p, c),
  },
  transactionConfig_exportForArmySkill: {
    /*
     * 导出-中军职达
     */
    get: (p, c) =>
      $.get("/api/ems/basic/transactionConfig/exportForArmySkill", p, c),
  },
  transactionConfig_exportForContinue: {
    /*
     * 导出-继续教育
     */
    get: (p, c) =>
      $.get("/api/ems/basic/transactionConfig/exportForContinue", p, c),
  },
  transactionConfig_exportForExemptionDegree: {
    /*
     * 导出-免试专升本
     */
    get: (p, c) =>
      $.get("/api/ems/basic/transactionConfig/exportForExemptionDegree", p, c),
  },
  transactionConfig_exportForSelfTaught: {
    /*
     * 导出-自考平台
     */
    get: (p, c) =>
      $.get("/api/ems/basic/transactionConfig/exportForSelfTaught", p, c),
  },
  transactionConfig_exportForSkillTrain: {
    /*
     * 导出-技能培训
     */
    get: (p, c) =>
      $.get("/api/ems/basic/transactionConfig/exportForSkillTrain", p, c),
  },
  transactionConfig_getAdultBatchOnceRoster: {
    /*
     * 获取成教单次转批次名单
     */
    get: (p, c) =>
      $.get("/api/ems/basic/transactionConfig/getAdultBatchOnceRoster", p, c),
  },
  transactionConfig_listAbleTradeType: {
    /*
     * 可申请的异动具体分类
     * applyPosition 申请角色：前端、后端 (string query required)
     * batch 批次 (string query required)
     * rollGrade 学籍年级 (string query required)
     * schoolStatus 学籍状态 (string query required)
     * siteId 学校id (integer query required)
     * type 异动分类 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/basic/transactionConfig/listAbleTradeType", p, c),
  },
  transactionConfig_listForAdult: {
    /*
     * 列表-学历教育
     */
    get: (p, c) => $.get("/api/ems/basic/transactionConfig/listForAdult", p, c),
  },
  transactionConfig_listForArmySkill: {
    /*
     * 列表-中军职达
     */
    get: (p, c) =>
      $.get("/api/ems/basic/transactionConfig/listForArmySkill", p, c),
  },
  transactionConfig_listForContinue: {
    /*
     * 列表-继续教育
     */
    get: (p, c) =>
      $.get("/api/ems/basic/transactionConfig/listForContinue", p, c),
  },
  transactionConfig_listForExemptionDegree: {
    /*
     * 列表-免试专升本
     */
    get: (p, c) =>
      $.get("/api/ems/basic/transactionConfig/listForExemptionDegree", p, c),
  },
  transactionConfig_listForSelfTaught: {
    /*
     * 列表-自考平台
     */
    get: (p, c) =>
      $.get("/api/ems/basic/transactionConfig/listForSelfTaught", p, c),
  },
  transactionConfig_listForSkillTrain: {
    /*
     * 列表-技能培训
     */
    get: (p, c) =>
      $.get("/api/ems/basic/transactionConfig/listForSkillTrain", p, c),
  },
  transactionConfig_listTradeType: {
    /*
     * 具体类型
     * type 分类 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/basic/transactionConfig/listTradeType", p, c),
  },
  transactionConfig_listType: {
    /*
     * 异动分类
     */
    get: (p, c) => $.get("/api/ems/basic/transactionConfig/listType", p, c),
  },
  transactionConfig_setAdultBatchOnceRoster: {
    /*
     * 设置成教单次转批次名单
     * amount  (string query )
     * batch  (string query )
     * id id (string query )
     * operateType 操作类型：添加，修改，删除，清空 (string query )
     * schoolRollId  (string query )
     */
    post: (p, c) =>
      $.post("/api/ems/basic/transactionConfig/setAdultBatchOnceRoster", p, c),
  },
  transactionConfig_upload: {
    /*
     * 导入
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/ems/basic/transactionConfig/upload", p, c),
  },
  transactionConfig_uploadAdultBatchOnceRoster: {
    /*
     * 导入成教单次转批次名单
     * file file (file formData required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/basic/transactionConfig/uploadAdultBatchOnceRoster",
        p,
        c
      ),
  },
};
